import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DateComponent} from './date/date.component';
import {InputComponent} from './input/input.component';
import {InputNumberComponent} from './input-number/input-number.component';
import {RadioGroupComponent} from './radio-group/radio-group.component';
import {SelectComponent} from './select/select.component';
import { InputDirective } from './input.directive';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule, MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule, MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule, MatSelectModule, MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule, MatSnackBarModule,
    MatSortModule,
    MatStepperModule, MatTableModule, MatTabsModule, MatToolbarModule,
    MatTooltipModule
} from '@angular/material';
import { DateRangeComponent } from './date-range/date-range.component';
import {NgxMaskModule} from "ngx-mask";
import {TextareaComponent} from "./textarea/textarea.component";
import { YearMonthDateComponent } from './year-month-date/year-month-date.component';


@NgModule({
    exports: [
        MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatStepperModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
    ]
})
export class DemoMaterialModule {}

@NgModule({
  declarations: [
    DateComponent,
    InputComponent,
    RadioGroupComponent,
    SelectComponent,
    InputDirective,
    DateRangeComponent,
    InputNumberComponent,
    TextareaComponent,
    YearMonthDateComponent
  ],
  exports:[
    InputDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    DemoMaterialModule,
    NgxMaskModule
  ],
  entryComponents: [
    SelectComponent, RadioGroupComponent, InputComponent, DateComponent,
    DateRangeComponent, InputNumberComponent, TextareaComponent, YearMonthDateComponent
  ]
})
export class InputModule {
}
